<template>
  <div class="hello">
    <a-table :columns="tableColumns1" :data-source="tableTata1">
      <span slot="action" slot-scope="text, record">
        <a @click="showModalTrue(record)">代理</a>
      </span>
    </a-table>
    <a-modal :title="Gmid" :visible="visible" okText="新增" cancelText="取消" @ok="addModal" @cancel="handleCancel" :dialog-style="{ top: '80px' }">
      <a-table :columns="tableColumns2" :data-source="tableTata2">
      </a-table>
    </a-modal>


    <a-modal :visible="visibleIpt" :confirm-loading="confirmLoading" okText="新增" cancelText="取消" @ok="handleSubmit" :dialog-style="{ top: '120px' }"
      @cancel="handleIptCancel">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
        <!-- <a-form-item label="Mid">
          <a-input v-decorator="['Mid', { rules: [{ required: true, message: 'Please input your Mid!' }] }]" />
        </a-form-item> -->
        <a-form-item label="target">
          <a-input v-decorator="['target', {initialValue:'127.0.0.1:22', rules: [{ required: true, message: 'Please input your target!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import request from '@/api/index'

const tableColumns1 = [
  {
    title: 'Mid',
    dataIndex: 'mid',
    key: 'mid',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

const tableTata1 = [];
const tableColumns2 = [
  {
    title: 'Mid',
    dataIndex: 'mid',
    key: 'mid',
  },
  {
    title: 'target',
    dataIndex: 'target',
    key: 'target',
  },
  {
    title: '代理IP',
    dataIndex: 'ip',
    key: 'ip',
  },
  {
    title: '代理端口',
    dataIndex: 'port',
    key: 'port',
  }
];

const tableTata2 = [];

export default {
  name: 'HelloWorld',
  data() {
    return {
      tableTata1,
      tableColumns1,
      tableTata2,
      tableColumns2,
      visible: false,
      visibleIpt: false,
      confirmLoading: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      Gmid: ''
    };
  },
  mounted() {
    this.initTable()
  },
  methods: {
    initTable() {
      request({ url: 'http://dl.tl.run/proxy/list' }).then((res) => {
        console.log(res.data)
        this.tableTata1 = res.data
      })
    },
    showModalTrue(record) {
      this.visible = true;
      this.Gmid = record.mid
      this.refreshTable()
    },



    refreshTable() {
      request({ url: 'http://dl.tl.run/proxy/get/' + this.Gmid }).then((res) => {
        console.log(res.data)
        this.tableTata2 = res.data.targets
      })
    },

    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    handleIptCancel() {
      this.visibleIpt = false;
    },
    addModal() {
      this.visibleIpt = true
    },

    handleSubmit(e) {
      let that = this
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          console.log('Received values of form: ', that.confirmLoading);
          let param1 = this.Gmid
          let param2 = values.target
          request({ url: 'http://dl.tl.run/proxy/' + param1 + '/' + param2 }).then((res) => {
            that.$message.info('保存成功');
            that.visibleIpt = false;
            that.confirmLoading = false;
            console.log(res)


            that.refreshTable()

          })
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
